import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'search' })
export class SearchPipe implements PipeTransform {
  transform(data: any[], searchKey: any = null, targetField: any = null) {
    if (!data || !searchKey) return data;

    if (targetField) {
      return data.filter((item: any) =>
        item[targetField].toLowerCase().includes(searchKey.toLowerCase()),
      );
    } else {
      return data.filter((item: any) => item.toLowerCase().includes(searchKey.toLowerCase()));
    }
  }
}
